import { useContext, useState } from "react";
import { createContext } from "react";

const SideBarContext = createContext();

export const SidebarContextProvider = (props) => {
    const [sidebarIsOpen, setSidebarIsOpen] = useState(true)

    const updateIsSidebarOpen = (sidebarStatus) => {
        setSidebarIsOpen(sidebarStatus);
    }
    return (
        <SideBarContext.Provider value={{ sidebarIsOpen, updateIsSidebarOpen }}>
            {props.children}
        </SideBarContext.Provider>
    )
}

export const useSidebarContext = () => useContext(SideBarContext);
